/**
 * @enum
 */
export const ThumbsPosition = {
  Left: 'LEFT',
  Bottom: 'BOTTOM',
};
